const LightStylesheet = () => {
  return (
    <head>
      <link rel="stylesheet" href="/css/light.css" />
    </head>
  );
};

export default LightStylesheet;
